import React, { ReactNode, useEffect } from 'react';
import { createPortal } from 'react-dom';

import styles from './Modal.module.scss';

export type ModalProps = {
  headerSlot?: ReactNode,
  bodySlot?: ReactNode,
  footerSlot?: ReactNode,
  hide?: () => void
}

const modalElement = document.getElementById('root');
const bodyElement = document.querySelector('body');
const modalOpenClass = 'modal-open';

const Modal: React.FC<ModalProps> = ({
  headerSlot, bodySlot, footerSlot, hide,
}) => {
  useEffect(() => {
    bodyElement.classList.add(modalOpenClass);

    return () => bodyElement.classList.remove(modalOpenClass);
  });

  const header = () => {
    if (!headerSlot) return null;

    return (
      <>
        <div className={styles.header}>
          {headerSlot}
          <button type="button" className={styles.closeBtn} onClick={hide}>x</button>
        </div>
      </>
    );
  };

  const body = () => {
    if (!bodySlot) return null;

    return (
      <>
        <div className={styles.header}>
          {bodySlot}
        </div>
      </>
    );
  };

  const footer = () => {
    if (!footerSlot) return null;

    return (
      <>
        <div className={styles.header}>
          {footerSlot}
        </div>
      </>
    );
  };

  return createPortal(
    <>
      <div
        className={styles.backdrop}
        onClick={hide}
        aria-label="Fechar modal"
        role="button"
        onKeyDown={hide}
        tabIndex={0}
      />
      <div className={styles.container}>
        { header() }
        { body() }
        { footer() }
      </div>
    </>,
    modalElement,
  );
};

export default Modal;
